export default __webpack_public_path__ + "static/media/impactsettings.b8d9492c.PNG";